
<div class="toggle"
     [ngClass]="{'toggle--toggled': toggled}"
     (click)="toggle()"
>
  <div class="toggle-circle">
    <i class="fa-solid fa-check"></i>
  </div>
</div>
